import {Button, Dropdown, Flex, PriorityIcon, Text} from '@priority-software/priority-style-react';
import React, {useCallback, useContext, useMemo, useState} from 'react';
import List from '../../../components/Common/List';
import {SearchDropdown} from '../../../components/commonOldtoNew';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {MenuItem} from '../../../_legacy/FormHeader/components/Menus/MenuItem';
import {highlightText} from '../../../_legacy/library/utils/highlightText';
import {AppSearchesContext} from '../AppSearchesContext';
import styles from './styles.module.scss';

const ChooseFieldDropdown = () => {
    const {filters, handleAddFilter, fields} = useContext(AppSearchesContext);
    const [isOpen, setIsOpen] = useState(!filters.length);
    const [searchValue, setSearchValue] = useState('');

    const filteredOptions = useMemo(
        () =>
            searchValue
                ? fields?.filter(field =>
                      field.title.toLowerCase().includes(searchValue.toLowerCase())
                  )
                : fields,
        [searchValue, fields]
    );

    const onAddFilter = useCallback(
        item => {
            handleAddFilter(item);
        },
        [handleAddFilter]
    );

    const list = useMemo(
        () => (
            <List
                autoHeight
                autoHeightMax={200}
                data={filteredOptions}
                renderItem={({item, index}) => (
                    <Dropdown.Item
                        divider={filteredOptions && index !== filteredOptions.length - 1}
                        onClick={() => onAddFilter(item)}
                        key={index}
                        index={index}
                    >
                        <MenuItem title={highlightText(item.title, searchValue)} />
                    </Dropdown.Item>
                )}
            />
        ),
        [filteredOptions, onAddFilter, searchValue]
    );

    return (
        <div className={styles.fieldsDropdownWrapper}>
            {filters?.length === 0 || isOpen ? (
                <SearchDropdown
                    open={isOpen}
                    openOnFocus
                    onOpen={() => setIsOpen(true)}
                    focusedIndex={0}
                    inputProps={{
                        value: searchValue,
                        onChange: setSearchValue,
                        autoFocus: false,
                        placeholder: getLocalizedText(texts.selectFieldPlaceholder),
                        size: 'large',
                        componentClasses: styles.searchInput
                    }}
                    onClose={() => setIsOpen(false)}
                    eventTypes={['touchstart', 'mousedown']}
                    circularNavigation
                >
                    <Dropdown.Content
                        componentClasses={styles.fieldsList}
                        forceUpword={filters?.length > 1}
                    >
                        <Dropdown.Section gradient>
                            {filteredOptions?.length ? (
                                list
                            ) : (
                                <EmptyState isFiltered={fields.length > 0} />
                            )}
                        </Dropdown.Section>
                    </Dropdown.Content>
                </SearchDropdown>
            ) : (
                <Button
                    skin="secondary"
                    prefixIcon={PriorityIcon.add}
                    size="large"
                    width="fullWidth"
                    onClick={() => setIsOpen(true)}
                />
            )}
        </div>
    );
};

const EmptyState = ({isFiltered}) => (
    <Dropdown.Item disabled>
        <Flex justifyContent="center" componentClasses={styles.emptyState}>
            <Text skin="paragraph-1">
                {isFiltered
                    ? getLocalizedText(texts.noSearchResults)
                    : getLocalizedText(texts.NoFieldEmptyState)}
            </Text>
        </Flex>
    </Dropdown.Item>
);

export default ChooseFieldDropdown;
